/* eslint-disable prettier/prettier */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect, useState } from "react";
import "./index.scss";
import  More  from "@/app/csr-src/assets/icons/more.svg";
import  CouponClose  from "@/app/csr-src/assets/icons/couponClose.svg";
import { Button } from "@mui/material";
import { COUPON_TYPES, LABEL_STATUS } from "./constant";
import  CouponUsed  from "@/app/csr-src/assets/icons/couponUsed.svg";
import { sendClickTrack, EXPOSURE_RECORD } from "@/tracks/25349"
import { EXPCONFIG_FAST } from "@/common-components-src/const/point";

interface CouponItem {
  couponDiscount?: string;
  limitDesc?: string;
  timeEnd?: string;
  couponLimitInfo?: string;
  key?: string;
  canUsed?: boolean;
  promoCode?: string;
  discount?: string;
  discountStr?: number;
  quota?: number;
  quotaStr?: string;
  label?: string;
  selected?: boolean;
  id?: string;
  couponType: number;
  couponStyle?: number;
  endTimeFormat?: string;
  limitStr?: string;
  statusLabel?: number;
  state?: number;
  couponId?: number;
  batchId?: string;
}
interface CouponProps {
  data?: Array<CouponItem> | undefined;
  currentTab: string;
  containerStyle?: React.CSSProperties;
  contentStyle?: React.CSSProperties;
  isShowUseBtn?:boolean;
}

export default function CouponCard(props: CouponProps) {
  const [isOpen, setIsOpen] = useState<string>("expand");
  const [currentId, setCurrentId] = useState<number>()
  const handdleCancelCoupon = (data:any) => {
    const { couponId, batchId } = data
    // 去券购页
    const url = `/s-for-addon?type=1&couponId=${couponId}&batchId=${batchId}`
    window.open(url)
    couponClickTrack("0", data)
  }
  const handleToggleChange = (flag:string, item:any) => {
    setCurrentId(item.couponId)
    setIsOpen(flag)
    const pos = flag === "expand" ? "2" : "1"
    couponClickTrack(pos, item)
  };
  const couponClickTrack = (clickPos: string, data: any) => {
    sendClickTrack.MyCoupon_Home_Coupon({
      clickPos: clickPos,
      ...getCouponParams(data),
    })
  };
  const getCouponParams = (coupon: any) => {
    return {
      couponId: String(coupon?.couponId) || "-100",
      batchId: String(coupon?.batchId) || "-100",
      couponSave: coupon?.discount || "-100",
      use_threshold: coupon?.quota || "-100",
      couponType: String(coupon?.couponType) as any || "-100",
    }
  };

  return (
    <div className="coupon-card-box-voucher profile-coupon-box">
      { props?.data?.length ?
        props.data.map((item:any)=>(
          <div 
            className={`coupon-card ${ props.currentTab === 'available' ? item.couponType !== 2 ? 'off_type':'free_type' : 'nouse_type'}`}
            key={JSON.stringify(item)}
            style={props?.containerStyle}
            exptag={"exp|" + EXPOSURE_RECORD.MyCoupon_Home_CouponExpo}
            data-exptag-config={EXPCONFIG_FAST}
            data-exptag-json-param={JSON.stringify(getCouponParams(item))}
          >
              <div className="coupon-content-wrap">
                <div className="coupon-box">
                <div className={`${item.couponType !== 2 ? "coupon-info" : "coupon-info-free"}`}>
                      {
                        item.couponType !== 2 ? 
                         <div>
                            <span className="coupon-off-big">£{item.discount} </span>
                            <span className="coupon-off-small small-data ml mr">Off</span>
                            { item.quota ? (
                              <span className="coupon-off-small small-data relative-bottom"> Over £{item.quota}</span>
                            ):null}
                            <p className="coupon-off-limit coupon-off-border info-color">Valid until {item.endTimeFormat}</p>
                        </div>  
                        :  
                        <div>
                            <span className="coupon-off-big">£{item.discount} </span>
                            <span className="coupon-off-small small-data mr">Shipping off</span>
                            <p className="coupon-off-limit coupon-off-border info-color">Valid until {item.endTimeFormat}</p>
                        </div>  
                      }
                     
                      {
                        props.currentTab === 'available' && props.isShowUseBtn && item.couponType !== 2 ? 
                        <Button color="secondary" className="use-btn" onClick={() => {handdleCancelCoupon(item);}}>Use
                        </Button> : null
                      }           
                    </div>
                    <div className={`${item.couponType !== 2 ? "coupon-content" : ""} ${item.couponId === currentId ? isOpen : ''}`}>
                      <div className="coupon-content-text" style={props?.contentStyle}>
                        {
                          item.couponType !== 2 ? (
                            <><p className={`coupon-off-limit limit-color ${isOpen === "expand" ? "coupon-off-ellipsis" : ""}`}>{item.limitStr}</p>
                            <p className="coupon-off-limit limit-color">Code: {item.couponId}</p></>
                          ): null
                          //  <p className="coupon-off-limit limit-color">No purchase limit</p>
                        }
                      </div>
                      { item.couponType !== 2 && (currentId === item.couponId && isOpen === "close" ? 
                          <CouponClose className="more-icon" onClick={()=>handleToggleChange('expand',item)}/>
                          :
                          <More className="more-icon" onClick={() => handleToggleChange('close',item)}/>)
                      }
                    </div>
                </div>
              </div>
              {
                props.currentTab === 'available' ? null :
                <div className="unuse_icon type_1">
                  {
                     item.state === 3 ? <CouponUsed /> : null
                  }
                </div>
              }     
          </div>
          ))
        : null
        }
    </div>
  );
}
